var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXBack = function SvgXBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.698 15.02 1.15 8.62a.843.843 0 0 1 0-1.257L7.698.966a.802.802 0 0 1 .59-.246c.474 0 .834.369.834.835 0 .228-.097.44-.246.597L2.899 7.997l5.977 5.836c.15.158.246.37.246.598 0 .474-.36.835-.835.835a.802.802 0 0 1-.589-.246Z"
  })));
};
export default SvgXBack;